import sha256 from 'crypto-js/sha256';

export function hashEmail(raw: string): string {
  const normalized = raw.trim().toLowerCase();
  return sha256(normalized).toString();
}
